import { SVGProps } from "react"

const Play2Icon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M14.9264 6.95775L5.57761 1.6455C5.42189 1.55363 5.24204 1.50336 5.05772 1.50016C4.87339 1.49697 4.69166 1.54097 4.53237 1.62737C4.37072 1.70993 4.23596 1.83152 4.14228 1.97935C4.04859 2.12718 3.99945 2.29578 4 2.46742V13.104C3.99945 13.2756 4.04859 13.4443 4.14228 13.5921C4.23596 13.7399 4.37072 13.8615 4.53237 13.9441C4.69166 14.0305 4.87339 14.0745 5.05772 14.0713C5.24204 14.0681 5.42189 14.0178 5.57761 13.9259L14.9264 8.61368C15.0796 8.52763 15.2064 8.40618 15.2944 8.26112C15.3823 8.11606 15.4286 7.9523 15.4286 7.78571C15.4286 7.61913 15.3823 7.45537 15.2944 7.31031C15.2064 7.16525 15.0796 7.0438 14.9264 6.95775Z"
        fill={"currentColor"}
      />
    </svg>
  )
}
export default Play2Icon
